/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Webplatform-ts V2 API
 * OpenAPI spec version: 2.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DataModelNetworkDetails,
  GetV2NetworksParams
} from '../../model';

import { webplatformProxyInstance } from '../../../../../lib/integrations/axios.ts';
import type { ErrorType } from '../../../../../lib/integrations/axios.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get Networks with filters
 * @summary Get Networks with filters
 */
export const getV2Networks = (
    params?: GetV2NetworksParams,
 options?: SecondParameter<typeof webplatformProxyInstance>,signal?: AbortSignal
) => {


      return webplatformProxyInstance<DataModelNetworkDetails[]>(
      {url: `/v2/networks`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetV2NetworksQueryKey = (params?: GetV2NetworksParams,) => {
    return [
    `/v2/networks`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetV2NetworksQueryOptions = <TData = Awaited<ReturnType<typeof getV2Networks>>, TError = ErrorType<unknown>>(params?: GetV2NetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Networks>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetV2NetworksQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getV2Networks>>> = ({ signal }) => getV2Networks(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getV2Networks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetV2NetworksQueryResult = NonNullable<Awaited<ReturnType<typeof getV2Networks>>>
export type GetV2NetworksQueryError = ErrorType<unknown>


export function useGetV2Networks<TData = Awaited<ReturnType<typeof getV2Networks>>, TError = ErrorType<unknown>>(
 params: undefined |  GetV2NetworksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Networks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2Networks>>,
          TError,
          Awaited<ReturnType<typeof getV2Networks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2Networks<TData = Awaited<ReturnType<typeof getV2Networks>>, TError = ErrorType<unknown>>(
 params?: GetV2NetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Networks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getV2Networks>>,
          TError,
          Awaited<ReturnType<typeof getV2Networks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetV2Networks<TData = Awaited<ReturnType<typeof getV2Networks>>, TError = ErrorType<unknown>>(
 params?: GetV2NetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Networks>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Networks with filters
 */

export function useGetV2Networks<TData = Awaited<ReturnType<typeof getV2Networks>>, TError = ErrorType<unknown>>(
 params?: GetV2NetworksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getV2Networks>>, TError, TData>>, request?: SecondParameter<typeof webplatformProxyInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetV2NetworksQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






